module.exports = __webpack_public_path__ + "static/img/icon-cloud.29c73c66.svg";